if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        
        if (this.submitButton) {
          this.submitButtonText = this.submitButton.querySelector('span');
        }

        this.hideErrors = this.dataset.hideErrors === 'true';
        
        // Initialize frequently bought together
        this.initializeFrequentlyBought();
      }

      initializeFrequentlyBought() {
        const frequentlyBoughtSection = document.querySelector('.frequently-bought-together');
        if (frequentlyBoughtSection) {
          this.setupFrequentlyBoughtEvents(frequentlyBoughtSection);
        }
      }

      setupFrequentlyBoughtEvents(section) {
        const checkboxes = section.querySelectorAll('.upsel_input');
        checkboxes.forEach(checkbox => {
          checkbox.addEventListener('change', this.handleUpsellCheckboxChange.bind(this));
        });
      }

      handleUpsellCheckboxChange() {
        this.updateMainAddToCartButton();
      }

      updateMainAddToCartButton() {
        if (!this.submitButtonText) return;
        
        const selectedUpsells = this.getSelectedUpsellProducts();
        
        if (selectedUpsells.length > 0) {
          if (!this.submitButton.dataset.originalText) {
            this.submitButton.dataset.originalText = this.submitButtonText.textContent;
          }
          this.submitButtonText.textContent = `Add to Cart`;
        } else {
          if (this.submitButton.dataset.originalText) {
            this.submitButtonText.textContent = this.submitButton.dataset.originalText;
            delete this.submitButton.dataset.originalText;
          }
        }
      }

      getSelectedUpsellProducts() {
  const selectedCheckboxes = document.querySelectorAll('.frequently-bought-together .upsel_input:checked');
  const selectedProducts = [];
  
  selectedCheckboxes.forEach(checkbox => {
    const variantId = checkbox.dataset.variantId;
    const sellingPlanId = checkbox.dataset.sellingPlanId; 

    if (variantId) {
      const productData = {
        variantId: variantId,
        quantity: 1
      };
      if (sellingPlanId) {
        productData.sellingPlanId = sellingPlanId;
      }

      selectedProducts.push(productData);
    }
  });

  return selectedProducts;
}


      onSubmitHandler(evt) {
        evt.preventDefault();
        
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        const loadingSpinner = this.querySelector('.loading__spinner');
        if (loadingSpinner) loadingSpinner.classList.remove('hidden');

        // Get selected upsell products
        const selectedUpsells = this.getSelectedUpsellProducts();
        
        // Create form data for main product
        const mainFormData = new FormData(this.form);
        const mainVariantId = mainFormData.get('id');
        const mainQuantity = mainFormData.get('quantity') || 1;

        // Add main product first, then upsells
        this.addMainProductThenUpsells(mainVariantId, mainQuantity, selectedUpsells)
          .then((finalCartData) => {
            this.handleCartSuccess(finalCartData);
            this.resetUpsellCheckboxes();
          })
          .catch((e) => {
            console.error('Error adding items to cart:', e);
            this.handleErrorMessage('Failed to add items to cart. Please try again.');
            this.error = true;
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (loadingSpinner) loadingSpinner.classList.add('hidden');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          });
      }

      async addMainProductThenUpsells(mainVariantId, mainQuantity, upsells) {
        // First add main product
        let cartData = await this.addSingleItemToCart(mainVariantId, mainQuantity);
        for (const upsell of upsells) {
  try {
    const newCartData = await this.addSingleItemToCart(
      upsell.variantId,
      upsell.quantity,
      upsell.sellingPlanId || null
    );
    cartData = newCartData;
  } catch (error) {
    console.warn('Failed to add upsell product:', error);
  }
}

        return cartData;
      }

     async addSingleItemToCart(variantId, quantity, sellingPlanId = null) {
  const config = fetchConfig('javascript');
  config.headers['X-Requested-With'] = 'XMLHttpRequest';
  delete config.headers['Content-Type'];

  const formData = new FormData();
  formData.append('id', variantId);
  formData.append('quantity', quantity);
  if (sellingPlanId) {
    formData.append('selling_plan', sellingPlanId);
  }

  if (this.cart) {
    formData.append(
      'sections',
      this.cart.getSectionsToRender().map((section) => section.id).join(',')
    );
    formData.append('sections_url', window.location.pathname);
    this.cart.setActiveElement(document.activeElement);
  }

  config.body = formData;

  const response = await fetch(`${routes.cart_add_url}`, config);
  const data = await response.json();

  if (data.status) {
    throw new Error(data.description);
  }

  return data;
}


      resetUpsellCheckboxes() {
        const checkboxes = document.querySelectorAll('.frequently-bought-together .upsel_input');
        checkboxes.forEach(checkbox => {
          checkbox.checked = false;
        });
        this.updateMainAddToCartButton();
      }

      handleCartSuccess(cartData) {
        console.log('Cart update successful - Full response:', cartData);
        
        // Reset button text
        if (this.submitButton.dataset.originalText) {
          this.submitButtonText.textContent = this.submitButton.dataset.originalText;
          delete this.submitButton.dataset.originalText;
        }

        if (!this.cart) {
          window.location = window.routes.cart_url;
          return;
        }

        // Check if we have proper section data
        if (!cartData.sections || Object.keys(cartData.sections).length === 0) {
          console.warn('No sections data in response, fetching fresh cart data');
          this.fetchFreshCartDataAndOpenDrawer();
          return;
        }

        // Use the cart's renderContents method to open drawer with products
        try {
          console.log('Rendering cart contents with sections:', Object.keys(cartData.sections));
          this.cart.renderContents(cartData);
        } catch (error) {
          console.error('Error in renderContents:', error);
          this.fetchFreshCartDataAndOpenDrawer();
        }

        // Publish cart update event if available
        if (typeof publish !== 'undefined' && window.PUB_SUB_EVENTS) {
          publish(window.PUB_SUB_EVENTS.cartUpdate, {
            source: 'product-form',
            productVariantId: new FormData(this.form).get('id'),
            cartData: cartData,
          });
        }

        this.error = false;

        const quickAddModal = this.closest('quick-add-modal');
        if (quickAddModal) {
          document.body.addEventListener(
            'modalClosed',
            () => {
              setTimeout(() => {
                this.cart.renderContents(cartData);
              });
            },
            { once: true }
          );
          quickAddModal.hide(true);
        }
      }

     async fetchFreshCartDataAndOpenDrawer() {
  try {
    console.log('Fetching fresh cart data to open drawer...');
    
    // Fetch sections data with all necessary section IDs
    const sectionIds = ['cart-drawer', 'cart-icon-bubble'];
    const sectionsResponse = await fetch(`/cart?section_id=${sectionIds.join(',')}`);
    const sectionsText = await sectionsResponse.text();
    
    // Parse sections HTML
    const parser = new DOMParser();
    const doc = parser.parseFromString(sectionsText, 'text/html');
    
    const sections = {
      'cart-drawer': doc.getElementById('CartDrawer')?.innerHTML || '',
      'cart-icon-bubble': doc.querySelector('.shopify-section')?.innerHTML || ''
    };
    
    // Fetch current cart JSON data
    const cartResponse = await fetch('/cart.js');
    const cartJson = await cartResponse.json();
    
    const fullCartData = {
      ...cartJson,
      sections: sections
    };
    
    console.log('Fresh cart data fetched, opening drawer:', fullCartData);
    
    // Remove is-empty class before rendering
    this.cart.classList.remove('is-empty');
    
    // Also remove from the inner element if it exists
    const innerEmpty = this.cart.querySelector('.drawer__inner-empty');
    if (innerEmpty) {
      innerEmpty.classList.add('hidden');
    }
    
    // Show the cart items section
    const cartItems = this.cart.querySelector('cart-drawer-items');
    if (cartItems) {
      cartItems.classList.remove('hidden');
    }
    
    this.cart.renderContents(fullCartData);
  } catch (error) {
    console.error('Error fetching fresh cart data:', error);
    // Fallback: just open the drawer and ensure it's not marked as empty
    this.cart.classList.remove('is-empty');
    this.cart.open();
  }
}

      handleCartError(cartData) {
        if (typeof publish !== 'undefined' && window.PUB_SUB_EVENTS) {
          publish(window.PUB_SUB_EVENTS.cartError, {
            source: 'product-form',
            productVariantId: new FormData(this.form).get('id'),
            errors: cartData.errors || cartData.description,
            message: cartData.message,
          });
        }
        
        this.handleErrorMessage(cartData.description);

        const soldOutMessage = this.submitButton?.querySelector('.sold-out-message');
        if (soldOutMessage) {
          this.submitButton.setAttribute('aria-disabled', true);
          this.submitButtonText.classList.add('hidden');
          soldOutMessage.classList.remove('hidden');
          this.error = true;
        }
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}